import { render, staticRenderFns } from "./AdministrationConfirmationInProgress.vue?vue&type=template&id=2a04fdc7&scoped=true"
import script from "./AdministrationConfirmationInProgress.vue?vue&type=script&lang=js"
export * from "./AdministrationConfirmationInProgress.vue?vue&type=script&lang=js"
import style0 from "./AdministrationConfirmationInProgress.vue?vue&type=style&index=0&id=2a04fdc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04fdc7",
  null
  
)

export default component.exports